const ADJECTIVES = [
  "Silver", "Golden", "Swift", "Brave", "Clever", "Calm", "Bold", "Sharp",
  "Quiet", "Fierce", "Bright", "Daring", "Lucky", "Wise", "Nimble", "Keen",
  "Sturdy", "Crafty", "Gentle", "Rapid",
];

const ANIMALS = [
  "Fox", "Eagle", "Panda", "Wolf", "Hawk", "Bear", "Lynx", "Otter",
  "Raven", "Crane", "Tiger", "Bison", "Viper", "Moose", "Finch", "Cobra",
  "Gecko", "Heron", "Koala", "Manta",
];

const ALIAS_KEY = "antiscam_daily_alias";

function generate(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  const num = String(Math.floor(1000 + Math.random() * 9000));
  return `${adj}${animal}#${num}`;
}

export function getAlias(): string {
  const stored = localStorage.getItem(ALIAS_KEY);
  if (stored) return stored;
  const fresh = generate();
  localStorage.setItem(ALIAS_KEY, fresh);
  return fresh;
}

export function rerollAlias(): string {
  const fresh = generate();
  localStorage.setItem(ALIAS_KEY, fresh);
  return fresh;
}
